import React from 'react';
import { find } from 'lodash';
import {
  Edit,
  showNotification,
  fetchStart,
  fetchEnd,
  refreshView
} from 'react-admin';
import { connect } from 'react-redux';
import { FormSpy } from 'react-final-form';
import { withStyles } from '@material-ui/core/styles';
import SplitMethodSummary from './SplitMethodSummary';
import { typeChoices } from './SplitMethodTypeLookups';
import SplitMethodApi from '../../core/apis/SplitMethodApi';
import LeaveConfirm from '../../core/components/LeaveConfirmWrapper';
import { removePathEnd, getInitials } from '../../core/utils';
import FormTitleBar from '../../core/components/FormTitleBar';
import EditToolbar from '../../core/components/edit/EditToolbar';
import NavigationPrompt from '../../core/components/NavigationPrompt';
import SimpleFormWithSave from '../../core/components/form/SimpleFormWithSave';
import { getIcError } from '../../core/providers/utils';

const styles = () => ({
  noActions: {
    marginTop: '0px'
  }
});

const SplitMethodTitle = ({ record }) => {
  return (
    <FormTitleBar
      name={record.name}
      showAvatar
      avatarContent={getInitials(record.name)}
    />
  );
};

class SplitMethodEdit extends React.Component {
  state = {
    whenBlockNavigation: false
  };

  handleFormIsDirty(dirty) {
    // Block navigation when the form is dirty
    this.setState({ whenBlockNavigation: dirty });
  }

  onBeforeDelete = () => {
    this.setState({ whenBlockNavigation: false });
  };

  handleSubmit = async ({ name, externalId, type, file }) => {
    const formData = new FormData();
    const {
      fetchEnd,
      fetchStart,
      showNotification,
      id,
      refreshView
    } = this.props;

    const splitMethodType = find(typeChoices, ['code', type]);

    fetchStart();

    if (name) {
      formData.append('name', name);
    }
    if (externalId) {
      formData.append('externalId', externalId);
    }
    if (id) {
      formData.append('id', id);
    }
    if (file) {
      formData.append('file', file.rawFile, file.title);
    }

    try {
      await SplitMethodApi.update(splitMethodType.id, formData);

      refreshView();
      showNotification('ra.notification.custom_updated_message');
    } catch (error) {
      showNotification('ra.notification.server', 'error', {
        messageArgs: { message: getIcError(error.response) }
      });
    } finally {
      fetchEnd();
    }
  };

  render() {
    const { whenBlockNavigation } = this.state;
    const {
      classes,
      fetchStart,
      fetchEnd,
      showNotification,
      crudGetOne,
      refreshView,
      hasCreatePermission,
      hasEditPermission,
      hasDeletePermission,
      userProfile,
      ...rest
    } = this.props;

    return (
      <React.Fragment>
        <NavigationPrompt
          when={whenBlockNavigation}
          adjustMatchingPath={removePathEnd}
          hasEditPermission={hasEditPermission}
        >
          {(isOpen, onConfirm, onCancel) => (
            <LeaveConfirm
              isOpen={isOpen}
              onConfirm={onConfirm}
              onClose={onCancel}
            />
          )}
        </NavigationPrompt>
        <Edit
          {...rest}
          undoable={false}
          title={<SplitMethodTitle />}
          classes={{ noActions: classes.noActions }}
        >
          <SimpleFormWithSave
            toolbar={
              <EditToolbar
                {...rest}
                hasEditPermission={hasEditPermission}
                hasDeletePermission={hasDeletePermission}
                onBeforeDelete={this.onBeforeDelete}
              />
            }
            variant="standard"
            margin="normal"
            onSave={this.handleSubmit}
          >
            <SplitMethodSummary />
            <FormSpy
              onChange={props => {
                const self = this;
                setTimeout(() => self.handleFormIsDirty(props.dirty), 1);
              }}
            />
          </SimpleFormWithSave>
        </Edit>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  showNotification,
  fetchStart,
  fetchEnd,
  refreshView
};

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(SplitMethodEdit));
